import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import KeirinPresentational from '../components/keirinStartList';
import * as  commonActions from '../actions/common';
import * as  keirinActions from '../actions/keirinActions';
import * as  raceActions from '../actions/races';

class KeirinStartList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updatePage: "",
      EventName: "",
      keirinList: [],
    }
    this.ExecuteUpdate = this.ExecuteUpdate.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    const { raceCode } = this.props.match.params
    this.props.raceActions.getRace(raceCode)
      .then(() => {
        if (this.props.race.race !== null) {
          this.setState({
            EventName: this.props.race.race.EventName,
          });
        }
      });

    this.props.keirinActions.getKeirinStartList(raceCode)
      .then(() => {
        this.setState({
          keirinList: this.props.keirin.keirinStartList,
        })
      });
  }
  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.updatePage !== this.state.updatePage) {
  //     this.props.commonActions.ResetUpdate();
  //     const { raceCode } = this.props.match.params
  //     this.props.scratchActions.getScratches(raceCode);
  //     this.setState({ updatePage: "" });
  //   }
  // }

  ExecuteUpdate() {
    this.getData();
  }
  render() {
    return <KeirinPresentational {...this.state} {...this.props} ExecuteUpdate={this.ExecuteUpdate} />
  }
}

const mapStateToProps = (completeStore) => {
  return {
    keirin: completeStore.keirin,
    race: completeStore.race,
    updatePage: completeStore.updatePage,
  };
};

const mapDispatchToProps = (dispatch) =>
  ({
    keirinActions: bindActionCreators(keirinActions, dispatch),
    raceActions: bindActionCreators(raceActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  });

export default connect(mapStateToProps, mapDispatchToProps)(KeirinStartList);